import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CargaArchivosCud } from './pages/CargaArchivosCud';
import { setDiscapacidadRoute } from '../../../actions/discapacidad/discapacidadActions';

const routes = {
  cargaArchivos: "carga"
}

export const ArchivosCud = ({match}) => {
  const dispatch = useDispatch();
  const { section } = match.params;
  const { route } = useSelector((state) => state.discapacidad);

  useEffect(() => dispatch(setDiscapacidadRoute(section)), [route]);

  return (
    <>
      {(section === routes.cargaArchivos) && <CargaArchivosCud />}
    </>
  );
}
